(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["feature-panel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function debounce(fn, wait) {
      var t;
      return function () {
        var args = arguments;
        var context = this;
        clearTimeout(t);
        t = setTimeout(function () {
          fn.apply(context, args);
        }, wait);
      };
    }

    // Shifts every other wrapped row of thumbnails to the right, creating a
    // staggered "brick" look. Flex-wrap doesn't expose which items start a
    // new row (that depends on live container width), so rows are detected
    // by comparing each item's offsetTop after layout, then re-measured on
    // resize and whenever the theme editor reloads this section.
    //
    // Uses transform (not margin) to shift a row: a margin change would add
    // to that row's box width and throw off .feature-panel__thumbs's own
    // justify-content: center, visibly de-centering the whole block.
    // transform repaints without affecting layout, so every row still
    // centers correctly and only *looks* shifted.
    //
    // Desktop only: below 750px the row is usually only a few px narrower
    // than the container (three large circles nearly fill a phone-width
    // row), so there's rarely enough slack for the offset to read as an
    // actual stagger — it just looked like a display glitch. Mobile stays a
    // clean aligned grid instead.
    var desktopMql = window.matchMedia('(min-width: 750px)');

    function applyStagger(container) {
      var items = Array.prototype.slice.call(container.children);
      if (!items.length) return;

      items.forEach(function (item) {
        item.style.transform = '';
      });

      if (!desktopMql.matches) return;

      var rows = [];
      var rowTop = null;
      items.forEach(function (item) {
        var top = item.offsetTop;
        if (rowTop === null || top > rowTop + 1) {
          rows.push([]);
          rowTop = top;
        }
        rows[rows.length - 1].push(item);
      });

      if (rows.length < 2) return;

      var containerWidth = container.clientWidth;

      rows.forEach(function (rowItems, rowIndex) {
        if (rowIndex % 2 !== 1) return;

        var first = rowItems[0];
        var last = rowItems[rowItems.length - 1];
        var rowWidth = last.offsetLeft + last.offsetWidth - first.offsetLeft;
        var slack = containerWidth - rowWidth;
        var desired = Math.round(first.offsetWidth / 2 + 10);
        var offset = Math.max(0, Math.min(desired, slack));
        if (offset <= 0) return;

        rowItems.forEach(function (item) {
          item.style.transform = 'translateX(' + offset + 'px)';
        });
      });
    }

    function applyAll() {
      document.querySelectorAll('.feature-panel__thumbs--stagger').forEach(applyStagger);
    }

    function init() {
      applyAll();
      window.addEventListener('resize', debounce(applyAll, 150));
      document.addEventListener('shopify:section:load', applyAll);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
